module.exports = __webpack_public_path__ + "static/img/DSC_0481.e7262b1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DSC_0481.jpeg
// module id = 307
// module chunks = 2